<template>
  <div class="wrapper sales-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("SALES MANAGEMENT") }}</h1>

          <div class="balance">
            <h2>{{ $t("This month's binary bonus") }}</h2>
            <div class="total-amount"><span>0.0001</span> USDT</div>
            <ul class="list">
              <li>
                <h3>{{ $t("LEFT USER") }}</h3>
                <div class="amount">
                  <span>10</span>
                </div>
              </li>
              <li>
                <h3>{{ $t("RIGHT USER") }}</h3>
                <div class="amount">
                  <span>10</span>
                </div>
              </li>
            </ul>
          </div>

          <div class="form">
            <form>
              <!-- トータル売上（左） -->
              <div class="input-area">
                <label class="label" for="allamount-left">
                  <input
                    type="text"
                    name=""
                    id="allamount-left"
                    value="1,000"
                    readonly
                  />
                  <span class="group-label"
                    >{{ $t("Total sales") }}（{{ $t("Left") }}）</span
                  >
                </label>
                <span class="currency-txt">USDT</span>
              </div>
              <!-- トータル売上（右） -->
              <div class="input-area">
                <label class="label" for="allamount-right">
                  <input
                    type="text"
                    name=""
                    id="allamount-right"
                    value="1,000"
                    readonly
                  />
                  <span class="group-label"
                    >{{ $t("Total sales") }}（{{ $t("Right") }}）</span
                  >
                </label>
                <span class="currency-txt">USDT</span>
              </div>
              <!-- バイナリー売上（左） -->
              <div class="input-area">
                <label class="label" for="binary-left">
                  <input
                    type="text"
                    name=""
                    id="binary-left"
                    value="1,000"
                    readonly
                  />
                  <span class="group-label"
                    >{{ $t("Binary sales") }}（{{ $t("Left") }}）</span
                  >
                </label>
                <span class="currency-txt">USDT</span>
              </div>
              <!-- バイナリー売上（右） -->
              <div class="input-area">
                <label class="label" for="binary-right">
                  <input
                    type="text"
                    name=""
                    id="binary-right"
                    value="1,000"
                    readonly
                  />
                  <span class="group-label"
                    >{{ $t("Binary sales") }}（{{ $t("Right") }}）</span
                  >
                </label>
                <span class="currency-txt">USDT</span>
              </div>
            </form>
          </div>
          <div class="link">
            <router-link to="/organizationchart" class="link-over">{{
              $t("Organization chart")
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer title="Sales" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Sales",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Sales",
    };
  },
  methods: {},
  computed: {},
  mounted: function () {},
};
</script>
